import styled from '@emotion/styled';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 20px;

  &.disabled {
    .slider {
      cursor: default;
      &::after {
        background-color: #353535;
      }

      .active,
      .cursor {
        cursor: default;
        background-color: #353535;
      }
    }
  }
`;

export const StyledSlider = styled.div`
  position: relative;
  height: 12px;
  width: 100%;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    background-color: rgba(22, 22, 22, 0.2);
    border-radius: 4px;
  }
`;

export const StyledActiveSlider = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  height: 2px;
  transform: translateY(-50%);
  background-color: #353535;
  border-radius: 4px;
  z-index: 2;
`;

export const StyledCursor = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #353535;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 3;
`;

export const StyledTooltip = styled.div`
  font-size: 12px;
  position: absolute;
  bottom: calc(100% + 13px);
  padding: 4px 10px;
  border-radius: 4px;
  background-color: #353535;
  color: black;
  font-weight: 500;

  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 6px;
    height: 6px;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    background-color: white;
  }
`;
